import externalEventCodes from 'event-system/codes/external';

class SingleProducerMeetingsStore {

  constructor(application, serverInterface) {

    this.cache = {};
    this.requestsBuffer = [];
    this.nextCallTimerReference = null;

    this.application = application;
    this.serverInterface = serverInterface;

  }

  setData(meetingsSet) {

    for (let postId in meetingsSet) {

      const meeting = meetingsSet[postId];
      const alreadyExists = this.cache[postId] !== void 0;

      this.cache[postId] = meeting;

      if (alreadyExists === true) {
        continue;
      }

      function handleMeetingEvent(name, data) {

        const meeting = data.meeting;
        const postId = meeting.postId;

        this.cache[postId] = meeting;

      }

      this.application.eventSystem.internal.eventFor(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_LIVE}:${postId}`, handleMeetingEvent.bind(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_LIVE}:${postId}`));
      this.application.eventSystem.internal.eventFor(this, `${externalEventCodes.MEETING_LIVE_STATUS_CHANGED}:${postId}`, handleMeetingEvent.bind(this, `${externalEventCodes.MEETING_LIVE_STATUS_CHANGED}:${postId}`));
      this.application.eventSystem.internal.eventFor(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_ENDED}:${postId}`, handleMeetingEvent.bind(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_ENDED}:${postId}`));
      this.application.eventSystem.internal.eventFor(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_READY}:${postId}`, handleMeetingEvent.bind(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_READY}:${postId}`));
      this.application.eventSystem.internal.eventFor(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_PROCESSED}:${postId}`, handleMeetingEvent.bind(this, `${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_PROCESSED}:${postId}`));

    }

  }

  async getSingleProducerMeetingByPostId(postId, skipCache = false) {

    let meeting = this.cache[postId];

    if (skipCache === false && meeting !== void 0) {
      return meeting;
    }

    meeting = await this.serverInterface.startup.community.singleProducerMeeting.getSingleProducerMeetingByPostId(postId);

    this.cache[postId] = meeting;

    return meeting;

  }

}

export default SingleProducerMeetingsStore;